import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

const LANGUAGE_KEY = 'language';

interface ILanguage {
  short: string;
  fullLang: string;
}


@Component({
  selector: 'app-language-switch',
  standalone: true,
  imports: [
    TranslateModule,
    CommonModule
  ],
  templateUrl: './language-switch.component.html',
  styleUrl: './language-switch.component.scss'
})
export class LanguageSwitchComponent {
  @Input() collapsedSidebar: boolean = true;
  shortLang: string = 'en';
  fullLang: string = 'languages.english';

  constructor(private translate: TranslateService) {
    const storageLanguage = localStorage.getItem(LANGUAGE_KEY);
    if (storageLanguage) {
      const language: ILanguage = JSON.parse(storageLanguage as string);
      this.switchLanguage(language.short, language.fullLang);
    } else {
      this.translate.setDefaultLang('en');
      this.switchLanguage(this.shortLang, this.fullLang);
    }
  }

  switchLanguage(lang: string, fullLang: string) {
    this.translate.use(lang);
    localStorage.setItem(LANGUAGE_KEY, JSON.stringify({ short: lang, fullLang: fullLang }));
    this.shortLang = lang;
    this.fullLang = fullLang;
  }
}
